// @flow

export const CHAT_BUBBLE_WIDTH = 62
export const CHAT_BUBBLE_HEIGHT = 62
